var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "down-arrow (2) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "botton"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.4433 33.5602L32.5013 42.5023L23.5592 33.5602C22.812 32.885 21.834 32.5227 20.8273 32.5481C19.8206 32.5736 18.8621 32.9848 18.15 33.6969C17.438 34.409 17.0267 35.3675 17.0013 36.3742C16.9758 37.3809 17.3382 38.3589 18.0134 39.1061L31.4838 52.5765C31.617 52.7108 31.7755 52.8174 31.9502 52.8902C32.1248 52.9629 32.3121 53.0004 32.5013 53.0004C32.6904 53.0004 32.8777 52.9629 33.0524 52.8902C33.227 52.8174 33.3855 52.7108 33.5187 52.5765L46.9892 39.1061C47.6644 38.3589 48.0267 37.3809 48.0013 36.3742C47.9758 35.3675 47.5646 34.409 46.8525 33.6969C46.1404 32.9848 45.1819 32.5736 44.1752 32.5481C43.1685 32.5227 42.1905 32.885 41.4433 33.5602Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.4838 33.0296C31.617 33.1639 31.7755 33.2706 31.9502 33.3433C32.1248 33.4161 32.3121 33.4535 32.5013 33.4535C32.6904 33.4535 32.8777 33.4161 33.0524 33.3433C33.227 33.2706 33.3855 33.1639 33.5187 33.0296L46.9892 19.5592C47.6644 18.812 48.0267 17.834 48.0013 16.8273C47.9758 15.8206 47.5646 14.8621 46.8525 14.15C46.1404 13.438 45.1819 13.0267 44.1752 13.0013C43.1685 12.9758 42.1905 13.3382 41.4433 14.0134L32.5013 22.8981L23.5592 14.0134C22.812 13.3382 21.834 12.9758 20.8273 13.0013C19.8206 13.0267 18.8621 13.438 18.15 14.15C17.438 14.8621 17.0267 15.8206 17.0013 16.8273C16.9758 17.834 17.3382 18.812 18.0134 19.5592L31.4838 33.0296Z",
    fill: "#2A2A2A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.fecb440463ffc382102aa67f0a677b04.svg";
export { ForwardRef as ReactComponent };